import { paymentActions } from './payments'
export const { resetState } = paymentActions
